import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import type { PlayerData } from '@/vite-env.d';

interface PlayerResponse {
  status: string;
  playerData?: PlayerData;
  message?: string;
}

/** Siempre pide datos frescos a la API — no usar player cacheado de validate-session */
export function usePlayerData(charId: number) {
  return useQuery({
    queryKey: ['home', 'player-data', charId],
    queryFn: async () => {
      const { data } = await api.get<PlayerResponse>('/api/v1/home/player-data');
      if (data.status !== 'success' || !data.playerData) {
        throw new Error(data.message ?? 'Failed to load player');
      }
      return data.playerData;
    },
    enabled: charId > 0,
    staleTime: 0,
    refetchOnMount: 'always',
    retry: 2,
  });
}
